<h1 mat-dialog-title>{{ editMode ? 'Edit' : 'New' }} {{ 'scheduler.setup.skills.single' | translate }}</h1>
<form (ngSubmit)="onOkClick()" [formGroup]="skillForm">
  <mat-form-field>
    <input (change)="onDescriptionChanged($event)" [value]="skill.description" formControlName="skillFC" matInput
      placeholder="Description" required type="text" />
      @if (skillForm.controls['skillFC']) {
        <mat-error>Please enter description !</mat-error>
      }
    </mat-form-field>

    <mat-dialog-actions>
      <span class="spacer"></span>
      <button (click)="onCancelClick()" mat-flat-button type="reset">Cancel</button>
      <button [disabled]="!skillForm.valid" color="primary" mat-raised-button type="submit">Add</button>
    </mat-dialog-actions>
  </form>